<template>
  <div>
    <!--This part is for showing the report and claim slip edit elements-->

    <template v-if="this.show_edit_display">

      <template v-if="report_loaded">

        <CharacterHeader class="container typed-on-paper" v-bind:character_id="report_info.character_id"
          v-bind:first_name="report_info.first_name" v-bind:last_name="report_info.last_name"
          v-bind:callsign="report_info.callsign" v-bind:rank_name="report_info.rank_name"
          v-bind:rank_abreviation="report_info.abreviation" v-bind:rank_image="report_info.image"
          v-bind:faction="report_info.faction" v-bind:portrait_seed="report_info.portrait_seed"
          v-bind:hist_unit_image="report_info.hist_unit_image" v-bind:character_decorations="decorations">
        </CharacterHeader>
        <br>
        <div class="clearfix">
          <div v-if="this.show_badgers_button">
            <button v-on:click="awardRevokeBadgers" class="float-left">{{ this.award_badgers_text.button_text
              }}</button>
            <!--            <span class="float-left padding-2-10">{{ this.award_badgers_text.info_text }}</span>-->
          </div>

          <div class="float-left">
            <!--<span>The author received {{ this.awarded_badgers_list.length }} Badgers.</span>-->
            <HideableDiv v-bind:changing-button="false">
              <template v-if="this.show_badgers_button" slot="buttonHidden">
                <span class="donor-button">This report earned {{ this.awarded_badgers_list.length }} cans.</span>
              </template>
              <span>Cans received from: {{ this.awarded_badgers_list.map(function (item) {
      return
      item.response_callsign;
    }).join(",")
                }}</span>
            </HideableDiv>
          </div>

          <div class="margin-left-right">
            <div v-if="this.show_check_can_button">
              <button style="float: left" v-on:click="linkToCanFate">Check Your Can</button>
            </div>
            <div class="float-right">
              <button v-if="this.show_edit_button" v-on:click="toggleEdit" class="float-right">Exit edit</button>
              <button v-if="this.show_edit_button" v-on:click="sendReport" class="float-right greenButton">Send
                report</button>
              <HideableDiv ref="safety" class="float-right" v-bind:changing-button="true">
                <template slot="buttonVisible">
                  <button class="redButton" v-on:click="deleteReport">Confirm delete</button>
                  <button>Cancel</button>
                </template>
                <template slot="buttonHidden">
                  <button class="redButton">Delete report</button>
                </template>
              </HideableDiv>
            </div>
            <div class="info-text float-right">
              {{ info_text }}
            </div>
          </div>
        </div>
        <br>
        <div class="typed-on-paper">
          <EditReportLW v-if="report_info.faction == 1" v-bind="report_info"></EditReportLW>
          <EditReportRAF v-else-if="report_info.faction == 2" v-bind="report_info"></EditReportRAF>
          <EditReportVVS v-else-if="report_info.faction == 3" v-bind="report_info"></EditReportVVS>
          <EditReportRA v-else-if="report_info.faction == 4" v-bind="report_info"></EditReportRA>
          <EditReportUSAAF v-else-if="report_info.faction == 5" v-bind="report_info"></EditReportUSAAF>
          <EditReportFARR v-else-if="report_info.faction == 6" v-bind="report_info"></EditReportFARR>
		      <EditReportFAF v-else-if="report_info.faction == 7" v-bind="report_info"></EditReportFAF>
        </div>
        <br>
        <div class="typed-on-paper">
          <EditClaimSlipLW v-if="report_info.faction == 1" v-bind="report_info"></EditClaimSlipLW>
          <EditClaimSlipRAF v-else-if="report_info.faction == 2" v-bind="report_info"></EditClaimSlipRAF>
          <EditClaimSlipVVS v-else-if="report_info.faction == 3" v-bind="report_info"></EditClaimSlipVVS>
          <EditClaimSlipRA v-else-if="report_info.faction == 4" v-bind="report_info"></EditClaimSlipRA>
          <EditClaimSlipUSAAF v-else-if="report_info.faction == 5" v-bind="report_info"></EditClaimSlipUSAAF>
          <EditClaimSlipFARR v-else-if="report_info.faction == 6" v-bind="report_info"></EditClaimSlipFARR>
		      <EditClaimSlipFAF v-else-if="report_info.faction == 7" v-bind="report_info"></EditClaimSlipFAF>
        </div>

      </template>


    </template>

    <!--This part is for showing the report and claim slip -->

    <template v-else>

      <!--<template v-if="report_info != undefined && report_details != undefined">-->
      <template v-if="report_loaded">
        <CharacterHeader class="container typed-on-paper" v-bind:character_id="report_info.character_id"
          v-bind:first_name="report_info.first_name" v-bind:last_name="report_info.last_name"
          v-bind:callsign="report_info.callsign" v-bind:rank_name="report_info.rank_name"
          v-bind:rank_abreviation="report_info.abreviation" v-bind:rank_image="report_info.image"
          v-bind:faction="report_info.faction" v-bind:portrait_seed="report_info.portrait_seed"
          v-bind:hist_unit_image="report_info.hist_unit_image" v-bind:character_decorations="decorations">
        </CharacterHeader>
        <br>
        <div class="clearfix">
          <div v-if="this.show_badgers_button">
            <!--            <img v-on:click="awardRevokeBadgers" title="Give Cans!" class="canImage float-left" src="https://i.imgur.com/PKgEb1I.png"/>-->
            <button v-on:click="awardRevokeBadgers" class="float-right">{{ this.award_badgers_text.button_text
              }}</button>
            <!--            <span class="float-left padding-2-10">{{ this.award_badgers_text.info_text }}</span>-->
          </div>

          <div>
            <!--<span>The author received {{ this.awarded_badgers_list.length }} Badgers.</span>-->
            <HideableDiv class="float-right" v-bind:changing-button="false">
              <template slot="buttonHidden">
                <span class="donor-button">This report earned {{ this.awarded_badgers_list.length }} cans.</span>
              </template>
              <span>Cans received from: {{ this.awarded_badgers_list.map(function (item) {
      return
      item.response_callsign;
    }).join(",")
                }}</span>
            </HideableDiv>
          </div>
          <div v-if="this.show_check_can_button">
            <button style="float: left" v-on:click="linkToCanFate">Check Your Can</button>
          </div>
          <div v-if="this.show_edit_button" class="clearfix">
            <button v-on:click="toggleEdit">Edit report</button>
          </div>
        </div>
        <br>
        <div class="typed-on-paper">
          <ReportLW v-if="report_info.faction == 1" v-bind="report_info"></ReportLW>
          <ReportRAF v-else-if="report_info.faction == 2" v-bind="report_info"></ReportRAF>
          <ReportVVS v-else-if="report_info.faction == 3" v-bind="report_info"></ReportVVS>
          <ReportRA v-else-if="report_info.faction == 4" v-bind="report_info"></ReportRA>
          <ReportUSAAF v-else-if="report_info.faction == 5" v-bind="report_info"></ReportUSAAF>
          <ReportFARR v-else-if="report_info.faction == 6" v-bind="report_info"></ReportFARR>
		      <ReportFAF v-else-if="report_info.faction == 7" v-bind="report_info"></ReportFAF>
        </div>
        <br>
        <div class="typed-on-paper">
          <ClaimSlipLW v-if="report_info.faction == 1" v-bind="report_info"></ClaimSlipLW>
          <ClaimSlipRAF v-else-if="report_info.faction == 2" v-bind="report_info"></ClaimSlipRAF>
          <ClaimSlipVVS v-else-if="report_info.faction == 3" v-bind="report_info"></ClaimSlipVVS>
          <ClaimSlipRA v-else-if="report_info.faction == 4" v-bind="report_info"></ClaimSlipRA>
          <ClaimSlipUSAAF v-else-if="report_info.faction == 5" v-bind="report_info"></ClaimSlipUSAAF>
          <ClaimSlipFARR v-else-if="report_info.faction==6" v-bind="report_info"></ClaimSlipFARR>
		      <ClaimSlipFAF v-else-if="report_info.faction == 7" v-bind="report_info"></ClaimSlipFAF>
        </div>
      </template>

      <template v-else>
        Loading report...
      </template>
    </template>
  </div>
</template>

<script>
import ReportLW from "./ReportLW"
import ReportRAF from "./ReportRAF"
import ReportUSAAF from "./ReportUSAAF"
import ReportVVS from "./ReportVVS"
import ReportRA from "./ReportRA"
import ReportFARR from "./ReportFARR"
import ReportFAF from "./ReportFAF"
import EditReportLW from "./EditReportLW"
import EditReportRAF from "./EditReportRAF"
import EditReportUSAAF from "./EditReportUSAAF"
import EditReportVVS from "./EditReportVVS"
import EditReportRA from "./EditReportRA"
import EditReportFARR from "./EditReportFARR"
import EditReportFAF from "./EditReportFAF"
import ClaimSlipRAF from "./ClaimSlipRAF"
import ClaimSlipUSAAF from "./ClaimSlipUSAAF"
import EditClaimSlipRAF from "./EditClaimSlipRAF"
import EditClaimSlipUSAAF from "./EditClaimSlipUSAAF"
import ClaimSlipLW from "./ClaimSlipLW"
import EditClaimSlipLW from "./EditClaimSlipLW"
import ClaimSlipVVS from "./ClaimSlipVVS"
import ClaimSlipFAF from "./ClaimSlipFAF"
import EditClaimSlipVVS from "./EditClaimSlipVVS"
import EditClaimSlipFAF from "./EditClaimSlipFAF"
import ClaimSlipRA from "./ClaimSlipRA"
import EditClaimSlipRA from "./EditClaimSlipRA"
import ClaimSlipFARR from "./ClaimSlipFARR"
import EditClaimSlipFARR from "./EditClaimSlipFARR"
import HideableDiv from "../basic_comp/HideableDiv"
import CharacterHeader from "../campaign/CharacterHeader"
import { mapState, mapGetters } from "vuex"
import DivLinkButton from "../basic_comp/DivLinkButton";

export default {
  name: "Report",
  components: {
    DivLinkButton,
    EditClaimSlipLW,
    ClaimSlipLW,
    EditClaimSlipRAF,
    EditClaimSlipUSAAF,
    ClaimSlipRAF,
    ClaimSlipUSAAF,
    ReportLW,
    ReportRAF,
    ReportUSAAF,
    ReportVVS,
	ReportFAF,
    ReportRA,
    EditReportLW,
    EditReportRAF,
    EditReportUSAAF,
    EditReportVVS,
	EditReportFAF,
    EditReportRA,
    ClaimSlipVVS,
	ClaimSlipFAF,
    EditClaimSlipVVS,
	EditClaimSlipFAF,
    EditClaimSlipRA,
    ClaimSlipRA,
    EditClaimSlipFARR,
    ClaimSlipFARR,
    EditReportFARR,
    HideableDiv,
    CharacterHeader,
    ReportFARR
  },
  mounted() {

    this.loadReportInfo();
  },
  data() {
    return {

      report_loaded: false,
      edit_display: false,
      user_id: null,
      send_button_text: "Send Report",
      info_text: "",
      send_button_active: true,

    }
  },
  computed: {

    show_edit_button: function () {
      return (this.missionStatusById(this.$route.params.mission_id) == 1
        && this.report_info != undefined
        && this.report_info.member_id == this.user_id);
    },

    show_edit_display: function () {
      return (this.missionStatusById(this.$route.params.mission_id) == 1
        && this.edit_display
        && this.report_info != undefined
        && this.report_info.member_id == this.user_id);
    },

    show_badgers_button: function () {
      return (this.report_info.member_id != this.user_id
        && this.user_id !== 0);
    },

    show_check_can_button: function () {
      return this.missionStatusById(this.$route.params.mission_id) == 1;
    },

    award_badgers_text: function () {
      let member_report_response = this.filterByKeys("report_response",
        {
          report_id: this.$route.params.report_id,
          member_id: this.user_id,
        }
      );
      if (member_report_response.length > 0) {
        return ({
          info_text: "You gave the author some cans. Changed your mind?",
          button_text: "Take back cans"
        })
      } else {
        return ({
          info_text: "Like this report?",
          button_text: "Give cans"
        })
      }
    },

    awarded_badgers_list: function () {
      return this.filterByKey("report_response", "report_id", this.$route.params.report_id);
    },

    ...mapState("missionStore", {
      report_info: state => state.report,
      report_details: state => state.report_details,
      decorations: state => state.decorations
    }),

    ...mapGetters("missionStore", [
      "missionById",
      "missionStatusById",
      "filterByKey",
      "filterByKeys"
    ])
  },
  watch: {
    '$route.params.report_id': function () {
      this.loadReportInfo();
    }
  },
  methods: {

    linkToCanFate: function (event) {

      window.open("https://cyc.konaber.eu/map_fate?pam_mission_id=" +
        this.$route.params.mission_id +
        "&pam_pilot_id=" +
        this.report_info.member_id)
    },

    loadReportInfo: async function () {

      this.report_loaded = false;
      this.user_id = await this.$auth.getUserId(this.$options.name);
      this.$store.dispatch('missionStore/loadReport',
        {
          caller: this.$options.name,
          report_id: this.$route.params.report_id,
          campaign_id: this.$route.params.campaign_id
        }
      ).then(response => {
        this.report_loaded = true;
      }).catch(error => {
        console.log(error.message);
      });

      if (this.$route.params.report_id < 0) {
        this.edit_display = true;
      }
    },

    toggleEdit: function () {

      this.edit_display = !this.edit_display;

    },

    sendReport: function () {

      this.info_text = "Sending...";
      this.$store.dispatch('missionStore/sendReport',
        {
          caller: this.$options.name,
          path: this.$route.path
        })
        .then(response => {

          this.info_text = response;

        })
        .catch(error => {
          this.info_text = "ERROR: " + error;

        });
    },

    deleteReport: function () {
      this.info_text = "Deleting...";
      this.$store.dispatch('missionStore/deleteReport',
        {
          caller: this.$options.name,
        })
        .then(response => {

          this.info_text = response;
          this.$refs.safety.toggleVisible();

        })
        .catch(error => {
          this.info_text = "ERROR: " + error;

        });
    },

    awardRevokeBadgers: async function () {

      this.$store.dispatch('missionStore/awardRevokeBadgers',
        {
          caller: this.$options.name,
          member_id: this.user_id,
        });

    }

  }
}
</script>

<style scoped>
.margin-left-right button {
  margin: 0px 5px;
}

.info-text {
  text-align: center;
  padding: 5px;
}

.donor-button {
  cursor: pointer;
}

.donor-button:hover {
  color: #F28900;
}

.canImage {
  max-height: 80px;
  cursor: pointer;
}

.canImage:active {
  transform: translateY(6px);
}

.greenButton {
  background: rgba(64, 107, 17, 0.79);
  color: #ffffff;
}

.greenButton:hover {
  background: rgba(165, 217, 108, 0.65);
  color: #ffffff;
}

.redButton {
  background: rgba(148, 30, 30, 0.84);
  color: #ffffff;
}

.redButton:hover {
  background: rgba(178, 77, 77, 0.84);
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/campaign/Report.vue